import { render, staticRenderFns } from "./CPAlerts.vue?vue&type=template&id=5851ac24&scoped=true&"
import script from "./CPAlerts.vue?vue&type=script&lang=ts&"
export * from "./CPAlerts.vue?vue&type=script&lang=ts&"
import style0 from "./CPAlerts.vue?vue&type=style&index=0&id=5851ac24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5851ac24",
  null
  
)

export default component.exports